const jQ = jQuery.noConflict();

function initVideoIframe() {
    var iframes = jQ('iframe[src*="youtube"], iframe[src*="vimeo"]');
    iframes.each(function() {
        jQ(this).wrap('<div class="video-container"></div>');
    });
}

export default initVideoIframe;